import useProfile from "./useProfile";
export default function useGenderAffinity() {
    var _useProfile = useProfile(), _useProfile_genderAffinity = _useProfile.genderAffinity, genderAffinity = _useProfile_genderAffinity === void 0 ? "all" : _useProfile_genderAffinity;
    return genderAffinity;
}
